

import React from 'react'
import Home from "../Components/home.component";
import About from "../Components/about.component";
import Work from "../Components/work.component";
import Testimonial from "../Components/testimonial.component";
import Contact from "../Components/contact.component";
import Footer from "../Components/footer.component";
import "../App.css";

const HomePage = () => {
	return (
		<div className="App">
			<Home />
			<About />
			<Work />
			{/* <Testimonial /> */}
			{/* <Contact /> */}
			<Footer />
		</div>
	);
}

export default HomePage